// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    version: '0.3.3',
    firebaseConfig: {
        apiKey: 'AIzaSyDDdRqbWpgLSXljHPevElDsiwL1pGOpLHo',
        authDomain: 'beanadmin-dev.firebaseapp.com',
        databaseURL: 'https://beanadmin-dev.firebaseio.com',
        projectId: 'beanadmin-dev',
        firestoreId: 'beanadmin-dev',
        storageBucket: 'beanadmin-dev.appspot.com',
        messagingSenderId: '249815828600'
    },
    cloudFunctionURL: 'https://us-central1-beanadmin-dev.cloudfunctions.net/app/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts